export interface IInviteActivationStartPayload {
  InviteToken: string;
}

export interface IInviteActivationCompleteForm {
  Email?: string;
  Password?: string;
  CurrentPassword?: string;
}

export interface IInviteActivationCompletePayload extends IInviteActivationCompleteForm {
  ActivationToken: string;
}

export interface IInviteActivation {
  ActivationToken: string;
  ExpiresIn: string;
  FirstNameMasked: string;
  PhoneMasked: string;
  Email: string;
  EmailReadOnly: boolean;
  EmailHasAccount: boolean;
}

export function toInviteActivation(raw: unknown): IInviteActivation | null {
  const activation = raw as IInviteActivation | null;
  if (!activation?.ActivationToken) {
    return null;
  }

  return {
    ActivationToken: activation.ActivationToken,
    ExpiresIn: activation.ExpiresIn ?? '',
    FirstNameMasked: activation.FirstNameMasked ?? '',
    PhoneMasked: activation.PhoneMasked ?? '',
    Email: activation.Email ?? '',
    EmailReadOnly: activation.EmailReadOnly === true,
    EmailHasAccount: activation.EmailHasAccount === true,
  };
}

export const REQUIRES_CURRENT_PASSWORD_HINT = /senha atual/i;

export const INVITE_ACTIVATION_PASSWORD_MIN_LENGTH = 6;
export const INVITE_ACTIVATION_PASSWORD_MAX_LENGTH = 100;
